/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { connect } from 'react-redux';

import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency, selectCurrentSalonId } from 'selectors/currentSalon.selectors';

import ReportTableContainer from 'reports/Common/ReportTable';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import { getRevenueSummary } from 'reports/utils';

const RevenueByStylistTable = ({ startDate, endDate, data, visits, currency, salonId }) => {
  const { t } = useTranslation();
  // this map is used to map the names of the stylists to the total price and discount of the products they sold
  // example {"Name":{totalProductPrice: number, totalDiscountPrice: number}}
  const nameServicesTotalPriceMap = {};
  const newVisits = {};
  const noShows = {};
  data.forEach((stylist) => {
    nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
  });
  const nameProductsTotalPriceMap = {};
  data.forEach((stylist) => {
    nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
    newVisits[stylist.name] = stylist.visits;
    noShows[stylist.name] = stylist.revenue_from_no_shows;
  });

  return (
    <div id="revenue-summary">
      <ReportTableContainer
        data={{
          rows: getRevenueSummary(nameServicesTotalPriceMap, nameProductsTotalPriceMap, noShows, newVisits, visits, currency, t),
        }}
        startDate={startDate}
        endDate={endDate}
        title={t('businessReports.revenueReports.revenueSummaryTitle')}
        linkText={t('businessReports.futureRevenue.getMoreBookings')}
        linkUrl={`/salon/${salonId}/communications/marketing`}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  currency: selectCurrentSalonCurrency(state),
});

const RevenueByStylistTableHoc = connect(mapStateToProps)(RevenueByStylistTable);

export default RevenueByStylistTableHoc;
